<template>
  <div v-if="isDev" class="article-seo-keywords-dev">
    <span class="dev-only-badge">DEV ONLY</span>
    <span class="article-seo-keywords-label">{{ t('articleDetails.seoKeywordsLabel') }}</span>
    <div v-if="keywords.length" class="article-seo-keywords-list">
      <span
        v-for="(keyword, i) in keywords"
        :key="i"
        class="article-seo-keyword-tag"
      >
        {{ keyword }}
      </span>
    </div>
    <span v-else class="article-seo-keywords-empty">{{ t('articleDetails.seoKeywordsEmpty') }}</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  keywords?: string[] | null
}

const props = withDefaults(defineProps<Props>(), {
  keywords: () => [],
})

const { t } = useI18n()
const isDev = import.meta.dev

const keywords = computed(() => props.keywords ?? [])
</script>

<style scoped>
.dev-only-badge {
  display: inline-block;
  padding: 4px 8px;
  background: #c00;
  color: #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-family: var(--font-inter);
  margin-bottom: 10px;
}

.article-seo-keywords-dev {
  margin-top: 24px;
  padding: 16px;
  background: var(--color-light-grey, #f7f7f7);
  border: 1px dashed var(--color-grey);
  border-radius: 8px;
  font-family: var(--font-inter);
}

.article-seo-keywords-label {
  display: block;
  font-size: var(--font-size-small, 14px);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--color-grey-dark);
  margin-bottom: 10px;
}

.article-seo-keywords-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.article-seo-keyword-tag {
  font-size: 13px;
  padding: 4px 10px;
  background: #fff;
  border: 1px solid var(--color-grey-light);
  border-radius: 6px;
  color: var(--color-dark-blue);
}

.article-seo-keywords-empty {
  font-size: var(--font-size-small, 14px);
  color: var(--color-grey-dark);
  font-style: italic;
}
</style>
